const values = [
  { label: "Favorable", value: 1 },
  { label: "Desfavorable", value: 2 },
  { label: "Incierto", value: 3 },
];

export default values;
